export const Input = (props: React.ComponentPropsWithoutRef<'input'>) => {
  return (
    <input
      className="bg-background-tertiary min-h-12 w-full rounded-2xl border border-black px-4 py-3 text-sm outline-none transition-all duration-200 focus:border-transparent"
      {...props}
    />
  );
};
